// Mirrors the server's TerminalStatuses (StatusSubmitted, StatusAutoClosed,
// StatusAutoCompleted, and sales' StatusSkipped).
const TERMINAL = ['submitted', 'auto_closed', 'auto_completed', 'skipped'];

export interface StatusItem {
  status?: string;
}

// Terminal = no further action possible on the task: it was submitted, skipped,
// or the system auto-closed it.
export const is_terminal = (item: StatusItem | null | undefined): boolean =>
  !!item && !!item.status && TERMINAL.includes(item.status);
